import { render, staticRenderFns } from "./BsRadio.vue?vue&type=template&id=4c60f05c&"
import script from "./BsRadio.vue?vue&type=script&lang=js&"
export * from "./BsRadio.vue?vue&type=script&lang=js&"
import style0 from "./BsRadio.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports